var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "robot-spec w" },
    _vm._l(_vm.list, function(item) {
      return _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col1" }, [
          item.icon ? _c("i", { class: [item.icon] }) : _vm._e(),
          _c("p", [_vm._v(_vm._s(item.title))])
        ]),
        _c(
          "div",
          { staticClass: "params" },
          _vm._l(item.params, function(item2) {
            return _c(
              "div",
              { staticClass: "param" },
              [
                _c("div", { staticClass: "col2" }, [_vm._v(_vm._s(item2[0]))]),
                typeof item2[1] === "string"
                  ? [
                      _c("div", { staticClass: "col3" }, [
                        _vm._v(_vm._s(item2[1]))
                      ])
                    ]
                  : [
                      _c(
                        "div",
                        { staticClass: "col3" },
                        _vm._l(item2[1], function(item3) {
                          return _c("p", [_vm._v(_vm._s(item3))])
                        })
                      )
                    ]
              ],
              2
            )
          })
        )
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c1a6e21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1a6e21","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robot/spec.vue
// module id = ZPyE
// module chunks = 0